// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3rIAf","right":"styles_right__3x7ez"};